const CALCULATION_VERSION = "v1.0.0";

module.exports = { CALCULATION_VERSION };